import {
  flexibleGrid, flexibleGridColumn,
  flexibleGridRows, flexibleGridColumnSpan,
} from '@bingads-webui-campaign-react/flexible-grid-styles';
import { legacySchedulingPanelStyles } from '@bingads-webui-campaign/ad-extensions-shared';

const FIELDS_COLUMN_WIDTH_PX = 383;
const SCHEDULING_EXTRA_COLUMN_WIDTH_PX = 490 - FIELDS_COLUMN_WIDTH_PX;

const genericFieldLabel = {
  display: 'flex',
  justifyContent: 'flex-start',
  textAlign: 'left',
  alignItems: 'baseline',
  marginBottom: '5px',
};

const genericEditorField = {
  marginBottom: '28px',
};

export const getPromotionExtensionEditorStyles =
  (components, theme = { palette: {} }) => ({
    outerGrid: {
      extend: flexibleGrid(),
      '-ms-grid-columns': `8px ${FIELDS_COLUMN_WIDTH_PX}px ${SCHEDULING_EXTRA_COLUMN_WIDTH_PX}px 60px 458px 8px`,
      gridTemplateColumns: `8px ${FIELDS_COLUMN_WIDTH_PX}px ${SCHEDULING_EXTRA_COLUMN_WIDTH_PX}px 60px 458px 8px`,
    },

    outerGridWithOneColumn: {
      extend: flexibleGrid(),
      '-ms-grid-columns': `8px ${FIELDS_COLUMN_WIDTH_PX}px ${SCHEDULING_EXTRA_COLUMN_WIDTH_PX}px 8px`,
      gridTemplateColumns: `8px ${FIELDS_COLUMN_WIDTH_PX}px ${SCHEDULING_EXTRA_COLUMN_WIDTH_PX}px 8px`,
    },

    ...flexibleGridRows(false, 'outerGrid', 1),

    editorFieldsColumn: {
      extend: flexibleGridColumn(2),
    },

    previewColumn: {
      extend: flexibleGridColumn(4),
    },

    fieldsGrid: {
      extend: flexibleGrid(),
      '-ms-grid-columns': '100%',
      gridTemplateColumns: '100%',
    },

    ...flexibleGridRows(false, 'fieldsGrid', 30),

    languageAndCurrencyGrid: {
      extend: flexibleGrid(),
      '-ms-grid-columns': '257px 16px 110px',
      gridTemplateColumns: '257px 16px 110px',
    },

    ...flexibleGridRows(false, 'languageAndCurrencyGrid', 2),

    currencyFieldLabel: {
      extend: [genericFieldLabel, flexibleGridColumn(3)],
    },

    currencyEditorField: {
      extend: [genericEditorField, flexibleGridColumn(3)],
    },

    editorFieldLabel: {
      extend: [genericFieldLabel, flexibleGridColumn(1)],
    },

    editorField: {
      extend: [genericEditorField, flexibleGridColumn(1)],
    },

    editorFieldNoMargin: {
      extend: flexibleGridColumn(1),
    },

    occasionSelect: {
      marginBottom: '9px',

      '& ~ .alert.alert-info[role=alert]': {
        display: 'flex',
        width: 'initial',
        paddingRight: '8px',
      },
    },

    alert: {
      '& .alert.alert-info[role=alert]': {
        display: 'flex',
      },
      marginBottom: '9px',
    },

    startAndEndDateContainer: {
      display: 'flex',
    },

    startAndEndDatePicker: {
      flexGrow: 1,
    },

    startAndEndDateSeparator: {
      padding: [[0, 8]],
      alignSelf: 'center',
    },

    promotionTypeAndDetailSelect: {
    },

    typeInputContainer: {
      display: 'flex',
      marginTop: '16px',
    },

    typeInput: {
      width: '152px',
    },

    typeInputExtraExtra: {
      alignSelf: 'center',
      marginLeft: '8px',
    },

    urlContainer: {
      display: 'flex',
    },

    urlProtocolSelect: {
      width: 'auto',
      marginRight: '10px',
    },

    collapsiblePanel: {
      extend: flexibleGridColumn(1),

      border: 'none',
      marginBottom: '28px',

      '& .panel-heading': {
        padding: 0,
        borderBottom: 'none',

        '& .panel-title': {
          fontSize: 14,
          '& > a': {
            marginLeft: '-8px', // compensate 8px padding on the left of icon
            color: theme.palette.themePrimary,
            padding: 0,
            '&:hover, &:active': {
              color: theme.palette.themeDarker,
              textTecoration: 'none',
              backgroundColor: 'unset',
            },
          },

          '& > a:after': {
            fontSize: 14,
            fontWeight: 'normal',
            padding: '0px 8px',
            content: '"\\E96E"',
          },

          // Reversing transformation after changing the
          // glyphicon to the one used in legacy code
          '& a[aria-expanded="true"]:after': {
            transform: 'rotate(180deg)',
            transformOrigin: 'center center',
            transition: 'transform 0.1s linear',
          },

          '& a.collapsed:after': {
            transform: 'unset',
            transformOrigin: 'unset',
            transition: 'unset',
          },
        },
      },

      '& .panel-collapse': {
        marginTop: 20,

        '& .panel-body': {
          padding: 0,
          overflow: 'hidden',
        },
      },
    },

    schedulingPanel: {
      extend: flexibleGridColumn(1),

      ...legacySchedulingPanelStyles(components, theme),
    },

    notices: {
      extend: flexibleGridColumnSpan(2),

      '& .alert.alert-info[role=alert]': {
        width: 'unset',
      },
    },

    editorButtonGroup: {
      extend: flexibleGridColumn(1),
      marginTop: '20px',

      '& button ~ button': {
        marginLeft: '16px',
      },
    },

    errors: {
      '& [role=alert]': {
        marginBottom: 18,

        '& .error a': {
          color: '#D90026',
        },
      },
    },
  });
